import { motion } from "framer-motion";
import { UserTable } from "@/components/admin/users/UserTable";
import { UserStatsCards } from "@/components/admin/users/UserStatsCards";
import { UserFilters } from "@/components/admin/users/UserFilters";

export default function Users() {
  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="text-3xl font-semibold tracking-tight">Users</h1>
        <p className="text-muted-foreground mt-1">
          Manage subscribers, view analytics, and handle subscriptions.
        </p>
      </motion.div>

      <UserStatsCards />
      <UserFilters />
      <UserTable />
    </div>
  );
}
